import React from 'react';
import { X } from 'lucide-react';
import { haptic } from '../utils/vibration';

const WindowModalHeader = ({
  icon: Icon,
  title,
  titleId,
  onClose,
  closeLabel = 'Закрыть окно',
}) => {
  const handleClose = (e) => {
    haptic('close');
    onClose?.(e);
  };

  return (
    <div className="flex h-[60px] shrink-0 select-none touch-none items-center justify-between border-b border-gray-200 px-4 dark:border-gray-700">
      <div className="flex min-w-0 items-center gap-2.5">
        {Icon ? (
          <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center text-gray-500 dark:text-gray-400">
            <Icon className="h-[18px] w-[18px]" />
          </span>
        ) : null}
        <h3 id={titleId} className="truncate text-base font-semibold text-gray-900 dark:text-white">
          {title}
        </h3>
      </div>
      <button
        type="button"
        onClick={handleClose}
        className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200"
        aria-label={closeLabel}
        title="Закрыть"
      >
        <X className="h-5 w-5" />
      </button>
    </div>
  );
};

export default WindowModalHeader;
